module.exports = __webpack_public_path__ + "nf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/nf.svg
// module id = 982
// module chunks = 0